import { render, staticRenderFns } from "./ModalBranch.vue?vue&type=template&id=3069a637&scoped=true&"
import script from "./ModalBranch.vue?vue&type=script&lang=js&"
export * from "./ModalBranch.vue?vue&type=script&lang=js&"
import style0 from "./ModalBranch.vue?vue&type=style&index=0&id=3069a637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3069a637",
  null
  
)

export default component.exports